import { Button, Icon } from "@elit-hair/elit-ui";
import { Link, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { TbCalendarTime, TbEdit } from "react-icons/tb";

import { AdminPageHeader } from "@/components/ui/admin-page-header";
import { ScheduleOverviewGrid } from "@/features/schedule/components/schedule-overview-grid";
import { APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute("/management/schedules/")({
    component: SchedulesOverviewPage,
    staticData: {
        config: {
            title: "schedule_overview",
        },
    },
});

function SchedulesOverviewPage() {
    const { t } = useTranslation();
    const navigate = Route.useNavigate();

    return (
        <div className="flex flex-col gap-5">
            <AdminPageHeader
                icon={<Icon icon={TbCalendarTime} size={20} />}
                title={t("schedule_overview")}
                description={t("schedule_overview_description")}
                actions={
                    <Button asChild className="shadow-sm">
                        <Link to={APP_ROUTES_TO.MANAGEMENT_SCHEDULES_MANAGE}>
                            <Icon icon={TbEdit} />
                            {t("schedule_overview_manage")}
                        </Link>
                    </Button>
                }
            />

            <ScheduleOverviewGrid
                onSelectUser={(userId) =>
                    navigate({
                        to: APP_ROUTES_TO.MANAGEMENT_SCHEDULES_MANAGE,
                        search: { userId },
                    })
                }
            />
        </div>
    );
}
